import { request } from '@utils';
import { LIMIT, ENTITY_TYPES_COMMENTS } from '@constants';

const getServiceVehicles = async (payload) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  const results = await request.get(`/v1/serviceVehicles`, payload);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getServiceVehiclesFilters = async (payload) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  if (!payload.order) {
    payload.order = 'asc';
    payload.orderBy = 'skuId';
  }

  const queryParams = `?page=${payload?.page}&pageSize=${payload?.pageSize}&order=${payload?.order}&orderBy=${payload?.orderBy}`;
  delete payload?.pageSize;
  delete payload?.page;
  delete payload?.order;
  delete payload?.orderBy;
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/serviceVehicles/filter${queryParams}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getServiceVehiclesEnums = async () => {
  const results = await request.get(`/v1/serviceVehicles/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getServiceVehicle = async (id) => {
  const results = await request.get(`/v1/serviceVehicles/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const patchServiceVehicle = async (id, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/serviceVehicles/${id}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postServiceVehiclesAssignee = async (id, payload) => {
  const param = {
    body: payload,
  };
  const results = await request.post(
    `/v1/serviceVehicles/${id}/actions/assign`,
    param
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postServiceVehiclesSelectedSlot = async (id, payload) => {
  const param = {
    body: payload,
  };
  const results = await request.post(
    `/v1/serviceVehicles/${id}/actions/selectSlot`,
    param
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postServiceVehiclesStatus = async (id, payload) => {
  const param = {
    body: payload,
  };
  const results = await request.post(
    `/v1/serviceVehicles/${id}/actions/status`,
    param
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postServiceVehiclesContactEmail = async (id) => {
  const param = {
    body: {},
  };
  const results = await request.post(
    `/v1/serviceVehicles/${id}/appointment-email`,
    param
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getServiceVehicleComments = async (entityId) => {
  const results = await request.get(
    `/v1/comments?entityID=${entityId}&entityType=${ENTITY_TYPES_COMMENTS.serviceVehicles}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addServiceVehiclesComment = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/comments`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editServiceVehiclesComment = async (commentId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/comments/${commentId}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteServiceVehiclesComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getServiceVehicles,
  getServiceVehicle,
  postServiceVehiclesAssignee,
  postServiceVehiclesSelectedSlot,
  postServiceVehiclesStatus,
  getServiceVehiclesEnums,
  patchServiceVehicle,
  getServiceVehiclesFilters,
  postServiceVehiclesContactEmail,
  getServiceVehicleComments,
  addServiceVehiclesComment,
  editServiceVehiclesComment,
  deleteServiceVehiclesComment,
};
